'use strict';

var dateFns = require('date-fns');
var parseISOTimeIntervalToDateInterval = require('./parseISOTimeIntervalToDateInterval.cjs');

const areISOTimePartIntervalsOverlapping = (l, r) => {
  return dateFns.areIntervalsOverlapping(
    parseISOTimeIntervalToDateInterval(l),
    parseISOTimeIntervalToDateInterval(r)
  );
};

module.exports = areISOTimePartIntervalsOverlapping;
//# sourceMappingURL=areISOTimePartIntervalsOverlapping.cjs.map
